




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { HttpOptions, ServerResponse } from '@/interface/common';
// 回调函数校验结果
import { encrypt } from '@/utils/common';

interface CallBackFunc {
  (): boolean; // 左边表示函数的输入类型，右边表示输出类型
}

@Component({
  name: 'SendVerificationCode',

})
export default class SendVerificationCode extends Vue {
  @Prop({
    type: Boolean,
    default: false
  }) isAuto!: boolean; // 是否自动发送验证码

  @Prop({
    type: String,
    default: '获取验证码'
  }) initText!: string;

  @Prop({
    type: Number,
    default: 60 // 倒计时起始值
  }) startTime!: number; // 加了感叹号之后，默认值才能生效

  @Prop({
    type: String,
    default: 's后重发'
  }) contDownText!: string; // 倒计时的时候的文字

  @Prop({
    type: String,
    default: '重发验证码'
  }) resendText!: string; // 重新发送的提示文字

  @Prop({
    type: Object,
    default: () => {
      return {};
    }
  }) requestOptions!: HttpOptions;

  @Prop({
    type: String,
    default: '',
  }) urlWord!: string; // URL拼接的字符串

  @Prop({
    type: Function,
    default: () => {
      return true;
    }
  }) validateFunc!: CallBackFunc; // 发送验证码前的校验

  time = this.startTime;
  auto = this.isAuto;

  // 倒计时
  countDown() {
    const timer = setInterval(() => {
      this.time--;

      if (this.time <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

  // 发送验证码
  sendVerificationCode(flag: string) {
    // 因为验证码的组件有可能嵌套在页面的子组件中，所以使用this.$parent调用父组件的方法可能会取不到
    if (!this.validateFunc()) {
      return false;
    }

    const options = {
      params: {},
      ...this.requestOptions
    };

    if (this.urlWord) {
      options.params['mobilePhoneEncrypt'] = encrypt(this.urlWord);
    }

    this.$http(options).then((res: ServerResponse) => {
      if (flag === 'first') {
        this.auto = true;
      }

      this.time = this.startTime;
      this.countDown();
      this.$toast.success('验证码已发送到您的手机，请查收！')

      this.$emit('getVerificationCodeKey', res.data);
    });
  }
}
